module.exports = __webpack_public_path__ + "assets/inbox-72217e770d8e07f15cf0c681f01dcebd.svg";